<div class="main-delete">
  <div class="text-part">
    <span class="text-part-title">{{ 'confirm_card_removing.title' | translate }}</span>
    <span class="text-part-info">{{ 'confirm_card_removing.description' | translate }}</span>
  </div>
  <div class="action-part">
    <button class="option-cancel option-shared" (click)="closeDialog(false)">{{ 'confirm_card_removing.cancel' | translate }}</button>
    <button class="option-delete option-shared" (click)="closeDialog(true)">{{ 'confirm_card_removing.remove' | translate }}</button>
  </div>
</div>
